import axios from 'axios';
import { decompressData } from '/src/utils/decompressData';

const baseUrl = import.meta.env.VITE_GEO_BOUNDARY_BASE_URL;

export const fetchCountyBoundaries = async (fips) => {
    // Get existing QGD data from localStorage
    const existingQGD = JSON.parse(localStorage.getItem('qgd')) || { zip: {}, fips: {}, state: {} };

    // Check if we need to fetch any data
    // Need to first check if fips object exists before checking geometry
    const needsFipsData = !existingQGD.fips[fips]?.geometry;

    // If we have all data, return early
    if (!needsFipsData) {
        return existingQGD.fips[fips];
    }

    try {
        const response = await axios.get(
            `${baseUrl}/us-county-boundaries/records?select=*&where=geoid=${fips}`
        );
        if (response.data && response.data.length > 0) {  // Check for array data
            existingQGD.fips[fips] = {
                ...existingQGD.fips[fips],  // Preserve existing FIPS data
                geometry: response.data[0].geometry  // Add geometry directly
            };

            // Save updated data back to localStorage
            // localStorage.setItem('qgd', JSON.stringify(existingQGD));
            
            return existingQGD.fips[fips];
        }
    } catch (error) {
        console.error('Error fetching QGD data:', error);
        if (error.response) {
            console.error('Error response:', error.response.data);
        }
        throw error;  // Propagate error to caller
    }
};

export const fetchStateBoundaries = async (stateAbbr) => {
    console.log('Fetching state boundary for:', stateAbbr);
    try {
        const response = await axios.get(
            `${baseUrl}/us-state-boundaries/records?select=*&where=stusab='${stateAbbr}'`
        );
        console.log('State boundary response:', response.data);
        if (response.data && response.data.results.length > 0) {

            const stateInfo = response.data.results[0];
            return {
                geometry: stateInfo
            };
        }
        return null;
    } catch (error) {
        console.error('Error fetching state boundary data:', error);
        throw error;
    }
};
